import {ComplaintStatus, EventStatus} from "../enums/status.enum";
import {UserRoleEnum} from "../enums/user-role.enum";
import {UserBlockEnum} from "../enums/user-block.enum";

export function documentTypes() {
  return [
    {code: '', description: ''},
    {code: "BID", description: "Bilhete de Identidade"},
    {code: "PASS", description: "passaporte"},
    {code: "BANK", description: "Cartão Bancário"},
    {code: "CAR", description: "Documento de Automóvel"},
    {code: "DRIVER", description: "Carta de condução"},
    {code: "RESIDENCE", description: "Cartão de Residência"},
    {code: "OTHER", description: "Outro"},
  ]
}

export function genders() {
  return [
    {code: '', description: ''},
    {code: "MALE", description: "Masculino"},
    {code: "FEMALE", description: "Feminino"}
  ]
}

export function categories() {
  return [
    {code: '', description: ''},
    {code: "PEOPLE", description: "Pessoa"},
    {code: "VEHICLE", description: "Veículo"},
    {code: "DOCUMENT", description: "Documento"},
    {code: "OTHER", description: "Outros"}
  ]
}

export function contactMotives(){
  return [
    {code: '', description: ''},
    {code: "GENERAL", description: "Geral"},
    {code: "IMPROVEMENT", description: "Melhoria"},
    {code: "BUG", description: "Problema"},
    {code: "OFFER", description: "Proposta"},
    {code: "OTHER", description: "Outros"},
  ]
}

//todo: I will be retrieved from the database, cache should be implemented.
export function provinces() {
  return [
    {code: '', description: ''},
    {code: 'BENGO', description: 'Bengo'},
    {code: 'BENGUELA', description: 'Benguela'},
    {code: 'BIE', description: 'Bié'},
    {code: 'CABINDA', description: 'Cabinda'},
    {code: 'CUANDO_CUBANGO', description: 'Cuando-Cubango'},
    {code: 'CUANZA_NORTE', description: 'Cuanza-Norte'},
    {code: 'CUANZA_SUL', description: 'Cuanza-Sul'},
    {code: 'CUNENE', description: 'Cunene'},
    {code: 'HUAMBO', description: 'Huambo'},
    {code: 'HUILA', description: 'Huíla'},
    {code: 'LUANDA', description: 'Luanda'},
    {code: 'LUNDA_NORTE', description: 'Lunda-Norte'},
    {code: 'LUNDA_SUL', description: 'Lunda-Sul'},
    {code: 'MALANJE', description: 'Malanje'},
    {code: 'MOXICO', description: 'Moxico'},
    {code: 'NAMIBE', description: 'Namibe'},
    {code: 'UIGE', description: 'Uíge'},
    {code: 'ZAIRE', description: 'Zaire'}
  ]
}

export function eventStatuses() {
  return [
    {code: '', description: ''},
    {code: EventStatus.PENDING, description: 'Pendente'},
    {code: EventStatus.ADJUSTMENT, description: 'Ajuste'},
    {code: EventStatus.ACTIVE, description: 'Activo'},
    {code: EventStatus.CLOSED, description: 'Fechado'},
  ]
}

export function complaintStatuses() {
  return [
    {code: '', description: ''},
    {code: ComplaintStatus.PENDING, description: 'Pendente'},
    {code: ComplaintStatus.CLOSED, description: 'Fechado'},
  ]
}

export function roles() {
  return [
    {code: '', description: ''},
    {code: UserRoleEnum.NORMAL, description: 'Normal'},
    {code: UserRoleEnum.MASTER, description: 'Master'},
    {code: UserRoleEnum.MODERATOR, description: 'Moderador'},
    {code: UserRoleEnum.ADMIN, description: 'Administrador'},
  ]
}

export function userBlockDurations(){
  return [
    {code: '', description: ''},
    {code: UserBlockEnum.WEEK, description: '1 Semana'},
    {code: UserBlockEnum.MONTH, description: '1 Mês'},
    {code: UserBlockEnum.YEAR, description: '1 Ano'},
  ]
}

